export default "__VITE_ASSET__CFpSvBoz__"